import { Pipe, PipeTransform } from '@angular/core';
import { ServiciosService }from './../../services/servicios.service'
@Pipe({
  name: 'obtenerPropiedadInicioDeServicio'
})
export class ObtenerPropiedadInicioDeServicioPipe implements PipeTransform {
    constructor(private serviciosService:ServiciosService){

    }
    //REcibe como parametro los servicios de una cotizacion o el id de una confirmacion y el origen del pipe
  transform(servicios: any, origen:any): any {
      let resultado:any;
      //Cerifica si el pipe viene de una cotizacion o una confirmacion
     if(origen == 'cotizacion'){//Cuando es una cotizacion  se recorre el arreglo de servicios
        for (const key in  servicios) {
            if ( servicios.hasOwnProperty(key)) {
                const servicio =  servicios[key];
                if(servicio.itinerario)
                   resultado = servicio.itinerario.inicioDeServicio //Regresa el resultado el inicio de servicio 
            }
        }
     } else { //Cuando es una confirmacion se buscan los servicios de esa confirmacion
        resultado = this.serviciosService.obtenerServiciosDeConfirmacion(servicios).snapshotChanges().take(1)
        .map(servicios => {
            let serviciosArr = [];
            servicios.forEach(servicio => {
                const $key = servicio.payload.doc.id;
                const data = { $key, ...servicio.payload.doc.data() };
                serviciosArr.push(data);
            });
            return serviciosArr.length > 0 ? serviciosArr[0].inicioDeServicio : null; //REgresa el primer servicio y su inicio del mismo
        });
     }
     return resultado
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-inicio-servicio.pipe.ts